import n from "react";
const c = function () {
  let o = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : !1;
  const [e, t] = n.useState(o);
  return {
    open: e,
    onToggleClick: () => t(!e)
  };
};
export { c as useToggle };